import createCachedSelector from 're-reselect';

const getId = (state, { id }) => id;
const getOutfit = ({ outfit = {} }) => outfit;

const cacheKey = (state, { id }) => `${id}`;

const inputs = [getId, getOutfit];

// Very simply, just check to see whether any of the equipped items
// in the outfit state slice has this ID; if so, it's equipped
const output = (id, outfit) => Object.keys(outfit).some(k => outfit[k] === id);

export default createCachedSelector(inputs, output)(cacheKey);